import { ProductPriceBasisType, QualityFormulaType } from '@local/lib';

import type { SpecState } from '../../qualityFormulaTypes';

/**
 * This spec's selected Price Components keys, comma-joined into one primitive string so a
 * `useShallow` selector built from this (see `FormulaTestingPanel`'s `useSpecStatePrimitiveBySpec`)
 * can shallow-compare it across renders — only meaningful for a Percentage spec scaling against
 * its own Price Components (see `ProductPriceBasisState`'s own doc comment). Returns `undefined`
 * for every other spec, so callers can tell "doesn't apply" apart from "applicable but nothing
 * selected yet" (an empty `selectedComponentKeys` array still joins to `''`, not `undefined`).
 */
export const getSelectedPriceComponentKeysJoined = (specState: SpecState): string | undefined => {
  const usesPriceComponents =
    specState.enabled &&
    specState.formulaType === QualityFormulaType.Percentage &&
    specState.priceBasis.type === ProductPriceBasisType.PriceComponents;
  return usesPriceComponents ? specState.priceBasis.selectedComponentKeys.join(',') : undefined;
};

/**
 * This spec's configured Deemed Price, stringified for the same `useShallow`-primitive reason as
 * `getSelectedPriceComponentKeysJoined` — only meaningful for a Percentage spec scaling against
 * its own Deemed Price. Returns `undefined` for every other spec.
 */
export const getDeemedPriceIfApplicable = (specState: SpecState): string | undefined => {
  const usesDeemedPrice =
    specState.enabled &&
    specState.formulaType === QualityFormulaType.Percentage &&
    specState.priceBasis.type === ProductPriceBasisType.DeemedPrice;
  return usesDeemedPrice ? String(specState.priceBasis.deemedPrice) : undefined;
};
